import {AutoSave} from '@flinkit/ra-form-layout'
import {makeStyles} from '@mui/styles'
import {required, SimpleForm, TextInput, useTranslate} from 'react-admin'

import ExtendedEdit from '../components/ExtendedEdit'
import {
  ChannelChatBotSettingsMessageInputs,
} from '../pages/ExternalChatPage/ChannelSettingsDialog'
import {ChatMessageChatBotAutoreplyTypesEnum} from '../types/graphqlSchema'

const Edit = ({disabled, id}) => {
  const styles = useStyles()
  return (
    <>
      <ExtendedEdit
        className={styles.root}
        id={id}
        resource="channel_chat_bot_users"
        redirect={false}
        title={useTranslate()('channel_chat_bot_users.title')}
      >
        <SimpleForm
          disabled={disabled}
          resetOptions={{keepDirtyValues: true}}
          toolbar={(
            <AutoSave
              confirmationDuration={false}
              debounce={1000}
              typographyProps={{display: 'none'}}
            />
          )}
        >
          <TextInput label="Opt-In Trigger" source="optInTrigger" validate={required()} />
          <ChannelChatBotSettingsMessageInputs
            autoreplyType={ChatMessageChatBotAutoreplyTypesEnum.MarketingOptIn}
            disabled={disabled}
          />
          <div className={styles.divider} />
          <TextInput
            disabled={disabled}
            source="optOutTrigger"
            validate={required()}
          />
          <ChannelChatBotSettingsMessageInputs
            autoreplyType={ChatMessageChatBotAutoreplyTypesEnum.MarketingOptOut}
            disabled={disabled}
          />
        </SimpleForm>
      </ExtendedEdit>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  divider: {
    borderTop: '1px solid #ccc',
    height: '1px',
    marginBottom: theme.remSpacing(2),
    marginTop: theme.remSpacing(3),
    width: '100%',
  },
  root: {
    '& .MuiTypography-root': {
      paddingBottom: theme.remSpacing(1),
    },
  },
}))

export {Edit}
